import { createContext } from "react";

export const POPOVER_IDS = [
    "goals-board-popover",
    "key-insights-popover",
    "remind-coach-to-call-client-popover",
    "coach-assistant-v1-popover",
    "plan-info-faq-popover",
    "upcoming-topics-popover",
] as const;

export type PopoverId = (typeof POPOVER_IDS)[number];

export const initialPopoverContext = {
    arePopoversInitialized: false,
    popoverIdsShown: new Set<PopoverId>(),
    markPopoverAsShown: (
        _popoverId: PopoverId,
        _temporary: boolean = false,
        _dismissForSeconds?: number,
    ) => {},
};

export const PopoverContext = createContext(initialPopoverContext);
